import axios from 'axios';

// --- API URL YAPILANDIRMASI ---
const getApiUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
      console.log('🔧 Local Ortam Algılandı: http://127.0.0.1:8000/api');
      return 'http://127.0.0.1:8000/api'; 
  }
  console.log('🌍 Canlı Ortam Algılandı: https://burofuchs-web-1.onrender.com/api');
  return 'https://burofuchs-web-1.onrender.com/api';
};

const API_URL = getApiUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 180000,
});

// --- AUTH INTERCEPTOR ---
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('burofuchs_auth_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// --- HATA YAKALAYICI INTERCEPTOR ---
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorData = error.response?.data || error.message;
    console.error('❌ API Hatası (Detay):', errorData);

    if (error.response?.status === 401) {
        localStorage.removeItem('burofuchs_auth_token');
        localStorage.removeItem('burofuchs_user');
    }

    if (error.response?.status === 422) {
        console.warn('⚠️ Parametre Hatası (422). Veri yapısını kontrol et.');
    }

    return Promise.reject(error);
  }
);

export const tokenManager = {
  getToken: () => localStorage.getItem('burofuchs_auth_token'),
  setToken: (token) => localStorage.setItem('burofuchs_auth_token', token),
  removeToken: () => {
      localStorage.removeItem('burofuchs_auth_token');
      localStorage.removeItem('burofuchs_user');
  },
  hasToken: () => !!localStorage.getItem('burofuchs_auth_token'),
};

export const apiService = {
  health: {
    check: () => api.get('/health'),
    checkDatabase: () => api.get('/health/db'),
  },

  auth: {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    logout: () => {
      tokenManager.removeToken();
      return Promise.resolve();
    },
    me: () => api.get('/auth/me'),
    
    // 🔥 SORUNU ÇÖZEN SATIR: 'updateMe' fonksiyonu eklendi
    updateMe: (data) => api.put('/auth/me', data),
    
    upgrade: () => api.post('/auth/upgrade'),
    verifyEmail: (token) => api.post('/auth/verify-email', { token }),
    
    googleLogin: (token) => {
        console.log("🚀 Google Access Token gönderiliyor...");
        return api.post('/auth/google', { access_token: token }); 
    },
    
    appleLogin: (token, user) => api.post('/auth/apple', { token, user }),
    createCheckoutSession: (interval) => api.post('/payments/create-checkout-session', { interval }), 
  },

  documents: {
    getAll: (params) => api.get('/documents', { params: params || {} }),
    getById: (id) => api.get(`/documents/${id}`),
    create: (data) => api.post('/documents', data),
    upload: (formData) => api.post('/documents/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
    update: (id, data) => api.put(`/documents/${id}`, data),
    download: (id) => api.get(`/documents/${id}/download`, { responseType: 'blob' }), 
    delete: (id) => api.delete(`/documents/${id}`),
    exportDatev: () => api.get('/documents/export/datev', { responseType: 'blob' }),
    chat: (id, question, language) => api.post(`/documents/${id}/chat`, { question, language }),
    translate: (id, language) => api.post(`/documents/${id}/translate`, { language }),
    analyze: (documentId) => api.post('/ai/analyze-document', { documentId }),
  },

  ai: {
    analyzeDocument: (documentId) => api.post('/ai/analyze-document', { documentId }),
    chat: (message, language = 'de') => api.post('/ai/chat', { question: message, language }),
  },

  invoices: {
    preview: (data) => api.post('/invoices/preview', data, { responseType: 'blob' }),
    send: (data) => api.post('/invoices/send', data),
  },

  templates: {
    generate: (data) => api.post('/templates/generate', data, { responseType: 'blob' }),
    send: (data) => api.post('/templates/send', data),
    sendPhysical: (data) => api.post('/templates/send-physical', data), 
    analyze: (formData) => api.post('/templates/analyze', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
  },
};

export default api;